// A QR CODE FOR THE DEMO'S OWN CHROME (TW-0135) — "show a QR code to scan with your phone", so a
// shop owner sitting at a laptop can put the demo in their hand the way their client will hold it.
//
// PORTED FROM apps/app/lib/qr.ts, its SVG half line for line. Not imported: the two are separate
// builds and neither may reach into the other's tree, which is the same reason that file says it
// was ported from the marketing site's. The PNG half stays there — it needs node:zlib and only the
// shop app has a shop asking for a file.
//
// ⚠ `qrcode-generator` IS LOADED ON DEMAND, and that is deliberate rather than tidy. This bundle is
// what every client at every counter downloads over a phone signal, for a feature exactly one shop
// in the world can reach (the demo). `loadQrModules` dynamic-imports it, so the library lands only
// when someone opens the modal and never in a real signing.

/** The code as a square of booleans, true where a module is dark. Error correction M, on Chris's word
 *  (2026-09-11: "if M is the safest i'm fine with it"): it repairs about 15% of a damaged code where L
 *  repairs 7%, and L's bigger squares were measured against it in docs/DECISIONS.md that day. */
export async function loadQrModules(data: string): Promise<boolean[][]> {
  const qrcode = (await import("qrcode-generator")).default;
  const qr = qrcode(0, "M");
  qr.addData(data);
  qr.make();
  const n = qr.getModuleCount();
  const rows: boolean[][] = [];
  for (let r = 0; r < n; r++) {
    const row: boolean[] = [];
    for (let c = 0; c < n; c++) row.push(qr.isDark(r, c));
    rows.push(row);
  }
  return rows;
}

/** One `<path d>` covering every dark module of the matrix, at `size` points square. Pure, so the
 *  same matrix always gives the same string — which is what a test can hold on to. */
export function qrPath(modules: boolean[][], size: number): string {
  const n = modules.length;
  if (!n) return "";
  const cell = size / n;
  let d = "";
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (modules[r][c]) {
        d += `M${(c * cell).toFixed(2)} ${(r * cell).toFixed(2)}h${cell.toFixed(2)}v${cell.toFixed(2)}h-${cell.toFixed(2)}z`;
      }
    }
  }
  return d;
}
